"use client";

// الصفحة الرئيسيّة العامّة (2026-10-05): الإطار المشترك + زرّ الدخول.
// المسجَّل يرى «الدخول إلى المنصّة» بدل «تسجيل الدخول». صفحة /login بالإطار نفسه.
import Link from "next/link";
import { useEffect, useState } from "react";
import { buttonClasses } from "@/components/ui/button";
import { LandingShell } from "@/components/landing/LandingShell";
import { getToken } from "@/lib/api";

export default function Home() {
  const [signedIn, setSignedIn] = useState(false);
  useEffect(() => setSignedIn(!!getToken()), []);

  return (
    <LandingShell>
      <Link
        href={signedIn ? "/dashboard" : "/login"}
        className={buttonClasses({ variant: "primary", size: "lg", className: "px-10" })}
      >
        {signedIn ? "الدخول إلى المنصّة" : "تسجيل الدخول"}
      </Link>
    </LandingShell>
  );
}
